import { MdMail, MdMessage } from "react-icons/md";

export default function CommunicationSection({}) {
  return (
    <div className="company__space-y-8">
      <div>
        <h3 className="company__text-lg company__font-semibold company__text-slate-900 company__mb-4">
          Paramètres d'Email
        </h3>
        <p className="company__text-sm company__text-slate-600 company__mb-4">
          Configurez les emails automatiques envoyés aux salariés
        </p>

        <div className="company__space-y-4">
          <div className="company__p-4 company__bg-white company__border company__border-slate-200 company__rounded-lg">
            <div className="company__flex company__items-start company__gap-3 company__mb-3">
              <MdMail
                className="company__w-5 company__h-5 company__text-blue-600"
                style={{ marginTop: "0.125rem" }}
              />
              <div className="company__flex-1">
                <h4 className="company__font-medium company__text-slate-900 company__mb-1">
                  Email d'invitation
                </h4>
                <p className="company__text-sm company__text-slate-600 company__mb-3">
                  Premier email envoyé au salarié pour débuter son parcours
                  d'adhésion
                </p>

                <div className="company__space-y-3">
                  <div>
                    <label className="company__block company__text-sm company__font-medium company__text-slate-700 company__mb-2">
                      Objet de l'email
                    </label>
                    <input
                      type="text"
                      placeholder="Votre adhésion à la complémentaire santé"
                      className="company__w-full company__px-4 company__py-2 company__border company__border-slate-300 company__rounded-lg company__focus-ring-2 company__focus-ring-blue-500 company__focus-border-transparent"
                    />
                  </div>

                  <div>
                    <label className="company__block company__text-sm company__font-medium company__text-slate-700 company__mb-2">
                      Nom de l'expéditeur
                    </label>
                    <input
                      type="text"
                      placeholder="Service RH"
                      className="company__w-full company__px-4 company__py-2 company__border company__border-slate-300 company__rounded-lg company__focus-ring-2 company__focus-ring-blue-500 company__focus-border-transparent"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="company__p-4 company__bg-white company__border company__border-slate-200 company__rounded-lg">
            <div className="company__flex company__items-start company__gap-3">
              <MdMessage
                className="company__w-5 company__h-5 company__text-blue-600"
                style={{ marginTop: "0.125rem" }}
              />
              <div className="company__flex-1">
                <h4 className="company__font-medium company__text-slate-900 company__mb-1">
                  Email de relance
                </h4>
                <p className="company__text-sm company__text-slate-600 company__mb-3">
                  Relance automatique pour les salariés n'ayant pas complété
                  leur adhésion
                </p>

                <div className="company__space-y-2">
                  <label className="company__flex company__items-center company__gap-2">
                    <input
                      type="checkbox"
                      className="company__w-4 company__h-4 company__text-blue-600 company__rounded"
                    />
                    <span className="company__text-sm company__text-slate-700">
                      Activer les relances automatiques
                    </span>
                  </label>

                  <div style={{ marginLeft: "1.5rem", marginTop: "0.75rem" }}>
                    <label className="company__block company__text-sm company__font-medium company__text-slate-700 company__mb-2">
                      Délai avant relance
                    </label>
                    <select className="company__px-4 company__py-2 company__border company__border-slate-300 company__rounded-lg company__focus-ring-2 company__focus-ring-blue-500 company__focus-border-transparent">
                      <option>3 jours</option>
                      <option>5 jours</option>
                      <option>7 jours</option>
                      <option>10 jours</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="company__border-t company__border-slate-200 company__pt-8">
        <h3 className="company__text-lg company__font-semibold company__text-slate-900 company__mb-4">
          Notifications
        </h3>
        <p className="company__text-sm company__text-slate-600 company__mb-4">
          Configurez les notifications pour le suivi RH
        </p>

        <div className="company__space-y-3">
          <label className="company__flex company__items-start company__gap-3 company__p-4 company__border company__border-slate-200 company__rounded-lg">
            <input
              type="checkbox"
              className="company__w-4 company__h-4 company__text-blue-600 company__rounded"
              style={{ marginTop: "0.25rem" }}
              defaultChecked
            />
            <div>
              <div className="company__font-medium company__text-slate-900">
                Notification d'adhésion complétée
              </div>
              <div className="company__text-sm company__text-slate-600 company__mt-1">
                Recevoir un email quand un salarié complète son adhésion
              </div>
            </div>
          </label>

          <label className="company__flex company__items-start company__gap-3 company__p-4 company__border company__border-slate-200 company__rounded-lg">
            <input
              type="checkbox"
              className="company__w-4 company__h-4 company__text-blue-600 company__rounded"
              style={{ marginTop: "0.25rem" }}
              defaultChecked
            />
            <div>
              <div className="company__font-medium company__text-slate-900">
                Rapport hebdomadaire
              </div>
              <div className="company__text-sm company__text-slate-600 company__mt-1">
                Synthèse hebdomadaire du taux de complétion
              </div>
            </div>
          </label>

          <label className="company__flex company__items-start company__gap-3 company__p-4 company__border company__border-slate-200 company__rounded-lg">
            <input
              type="checkbox"
              className="company__w-4 company__h-4 company__text-blue-600 company__rounded"
              style={{ marginTop: "0.25rem" }}
            />
            <div>
              <div className="company__font-medium company__text-slate-900">
                Alertes de blocage
              </div>
              <div className="company__text-sm company__text-slate-600 company__mt-1">
                Alerte si un salarié rencontre un problème technique
              </div>
            </div>
          </label>
        </div>

        <div className="company__mt-4 company__p-4 company__bg-slate-50 company__border company__border-slate-200 company__rounded-lg">
          <label className="company__block company__text-sm company__font-medium company__text-slate-700 company__mb-2">
            Email(s) de notification (séparés par des virgules)
          </label>
          <input
            type="text"
            placeholder="rh@entreprise.com, manager@entreprise.com"
            className="company__w-full company__px-4 company__py-2 company__border company__border-slate-300 company__rounded-lg company__focus-ring-2 company__focus-ring-blue-500 company__focus-border-transparent"
          />
        </div>
      </div>

      <div className="company__border-t company__border-slate-200 company__pt-8">
        <h3 className="company__text-lg company__font-semibold company__text-slate-900 company__mb-4">
          Messages Personnalisés
        </h3>
        <p className="company__text-sm company__text-slate-600 company__mb-4">
          Ajoutez un message personnalisé visible par les salariés pendant leur
          parcours
        </p>

        <div>
          <label className="company__block company__text-sm company__font-medium company__text-slate-700 company__mb-2">
            Message d'accueil (optionnel)
          </label>
          <textarea
            rows={4}
            placeholder="Ex: Bienvenue dans votre espace d'adhésion. N'hésitez pas à contacter le service RH si vous avez des questions."
            className="company__w-full company__px-4 company__py-2 company__border company__border-slate-300 company__rounded-lg company__focus-ring-2 company__focus-ring-blue-500 company__focus-border-transparent"
          />
        </div>
      </div>
    </div>
  );
}
